import script from "./CriterionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CriterionCard.vue?vue&type=script&setup=true&lang=js"

import "./CriterionCard.vue?vue&type=style&index=0&id=ef19425e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef19425e"]])

export default __exports__